import { cash_register_navigation } from './cash-register';
import { monitoring_navigation } from './monitoring';
import { orders_navigation } from './orders';
import { products_navigation } from './products';
import { reservations_navigation } from './reservations';
import { users_navigation } from './users';
import { tables_navigation } from './tables';

const navsConfig = [
  users_navigation,
  orders_navigation,
  products_navigation,
  // categories_navigation,
  // ingredient_navigation,
  // provide_navigation,
  // recipes_navigation,
  // shopping_navigation,
  // ingredient_price_navigation,
  reservations_navigation,
  // plans_navigation,
  cash_register_navigation,
  monitoring_navigation,
  // canceled_products_navigation,
  tables_navigation,
];
export default navsConfig;
